import React from 'react';
import { SkeletonLoadingGroup } from '../skeleton-loading-group/skeleton-loading-group.component';
import { TableRow } from '../table-row/table-row.component';

export interface TableLoadingStateProps {
  /** Number of columns to span */
  colSpan: number;
  /** Number of skeleton rows to show */
  numberOfRows?: number;
  /** Whether to use header styling for skeleton text */
  header?: boolean;
  /** Margin between skeleton rows */
  marginBottom?: 'half' | 'one';
  /** Test ID for the loading group */
  testId?: string;
}

/**
 * Shared loading state component for tables.
 * Renders skeleton loading rows within a table row that spans all columns.
 */
export const TableLoadingState: React.FC<TableLoadingStateProps> = ({
  colSpan,
  numberOfRows = 3,
  header = false,
  marginBottom = 'one',
  testId = 'TableLoadingState',
}) => (
  <TableRow colSpan={colSpan}>
    <SkeletonLoadingGroup
      numberOfRows={numberOfRows}
      header={header}
      marginBottom={marginBottom}
      testId={testId}
    />
  </TableRow>
);
